/**
 * Catálogos de preenchimento rápido. São sugestões: tudo pode ser editado,
 * removido ou substituído por conteúdo específico da máquina.
 */

export const CATALOGO_EPI = [
  'Óculos de segurança',
  'Protetor auricular',
  'Luva de segurança',
  'Calçado de segurança',
  'Uniforme de mangas longas',
  'Protetor facial',
  'Máscara respiratória',
  'Capacete de segurança',
  'Avental de raspa',
  'Luva térmica',
];

export const CATALOGO_EPC = [
  'Proteção fixa com fixação por ferramenta',
  'Proteção móvel intertravada',
  'Cortina de luz de segurança',
  'Botoeira de parada de emergência',
  'Chave seccionadora com bloqueio',
  'Sinalizador luminoso e sonoro',
  'Grade de delimitação de área',
  'Tapete de segurança',
  'Comando bimanual',
  'Sistema de exaustão',
];

export const CATALOGO_TREINAMENTOS = [
  'NR-12 — Segurança no trabalho em máquinas e equipamentos',
  'NR-10 — Segurança em instalações e serviços em eletricidade',
  'NR-11 — Transporte, movimentação, armazenagem e manuseio de materiais',
  'NR-06 — Uso de equipamentos de proteção individual',
  'NR-33 — Espaços confinados',
  'NR-35 — Trabalho em altura',
  'Treinamento operacional específico da máquina',
  'Bloqueio e etiquetagem de energias (LOTO)',
  'Primeiros socorros e resposta a emergências',
];

export const CATALOGO_NORMAS = [
  { codigo: 'NR-12', titulo: 'Segurança no trabalho em máquinas e equipamentos', ano: '2022' },
  { codigo: 'NR-10', titulo: 'Segurança em instalações e serviços em eletricidade', ano: '2019' },
  { codigo: 'NR-06', titulo: 'Equipamento de proteção individual', ano: '2022' },
  { codigo: 'NR-26', titulo: 'Sinalização de segurança', ano: '2015' },
  { codigo: 'ABNT NBR ISO 12100', titulo: 'Segurança de máquinas — princípios gerais de projeto', ano: '2013' },
  { codigo: 'ABNT NBR 16746', titulo: 'Segurança de máquinas — manual de instruções — princípios gerais de elaboração', ano: '2019' },
  { codigo: 'ABNT NBR ISO 13849-1', titulo: 'Partes de sistemas de comando relacionadas à segurança', ano: '2019' },
  { codigo: 'ABNT NBR ISO 13857', titulo: 'Distâncias de segurança para membros superiores e inferiores', ano: '2021' },
  { codigo: 'ABNT NBR ISO 14118', titulo: 'Prevenção de partida inesperada', ano: '2020' },
  { codigo: 'ABNT NBR ISO 13850', titulo: 'Função de parada de emergência', ano: '2017' },
  { codigo: 'ABNT NBR IEC 60204-1', titulo: 'Equipamentos elétricos de máquinas', ano: '2021' },
];

export const CATALOGO_PUBLICO = [
  'Operador de produção',
  'Líder ou supervisor de produção',
  'Manutentor mecânico',
  'Manutentor elétrico',
  'Técnico de segurança do trabalho',
  'Profissional de limpeza industrial',
  'Instalador e montador',
];

export const CATALOGO_ENERGIAS = [
  'Elétrica',
  'Hidráulica',
  'Pneumática',
  'Térmica',
  'Mecânica (gravitacional)',
  'Mecânica (energia acumulada em molas)',
];

export const CATALOGO_PERIODICIDADE = [
  'Diária',
  'Semanal',
  'Quinzenal',
  'Mensal',
  'Trimestral',
  'Semestral',
  'Anual',
  'A cada 500 h de operação',
  'Conforme necessidade',
  'Conforme validação',
];

/**
 * Plano de manutenção preventiva do manual-modelo (prensa hidráulica de
 * buchas), generalizado. Entra pronto em todo manual novo: o levantamento
 * remove o que não existe na máquina e acrescenta o que for específico.
 * Periodicidades são as do modelo; o setor de manutenção da unidade pode
 * alterá-las (há um bloco INFORMAÇÃO no documento dizendo isso).
 */
export const PLANO_MANUTENCAO_PADRAO: { parte: string; tarefa: string; metodo: string; periodicidade: string; responsavel: string }[] = [
  { parte: 'Proteções e carenagens', tarefa: 'Verificar o estado de conservação das proteções fixas e móveis: fixação, pontos de impacto, deformações e oxidação. Substituir a proteção que tiver a estrutura comprometida.', metodo: 'Inspeção visual', periodicidade: 'Diária', responsavel: 'Operação' },
  { parte: 'Proteções e carenagens', tarefa: 'Verificar o estado de conservação das portas e proteções móveis, dobradiças e fechos.', metodo: 'Inspeção visual', periodicidade: 'Diária', responsavel: 'Operação' },
  { parte: 'Proteções e carenagens', tarefa: 'Limpar as proteções da máquina com pano úmido, sem produtos químicos.', metodo: 'Limpeza', periodicidade: 'Semestral', responsavel: 'Operação' },
  { parte: 'Dispositivos de segurança e emergência', tarefa: 'Verificar se os botões de emergência param a máquina e travam quando acionados.', metodo: 'Teste funcional', periodicidade: 'Semanal', responsavel: 'Operação' },
  { parte: 'Dispositivos de segurança e emergência', tarefa: 'Verificar se os dispositivos de intertravamento das proteções móveis interrompem o movimento ao abrir a proteção.', metodo: 'Teste funcional', periodicidade: 'Diária', responsavel: 'Operação' },
  { parte: 'Dispositivos de segurança e emergência', tarefa: 'Verificar o estado de conservação dos dispositivos de segurança: botoeiras de emergência, intertravamentos, proteções mecânicas e carenagens (pintura, deformações, oxidação).', metodo: 'Inspeção visual', periodicidade: 'Diária', responsavel: 'Operação' },
  { parte: 'Dispositivos de segurança e emergência', tarefa: 'Substituir botões de emergência, contatores de segurança, CLP/relé de segurança e válvulas de segurança ao término do tempo de missão calculado no relatório de validação.', metodo: 'Manutenção preditiva', periodicidade: 'Conforme validação', responsavel: 'Manutenção' },
  { parte: 'Painel elétrico', tarefa: 'Reapertar e inspecionar as conexões dos dispositivos e borneiras.', metodo: 'Manutenção preventiva', periodicidade: 'Semestral', responsavel: 'Manutenção' },
  { parte: 'Painel elétrico', tarefa: 'Verificar limpeza e organização interna do painel e a integridade das vedações da porta.', metodo: 'Inspeção visual', periodicidade: 'Trimestral', responsavel: 'Manutenção' },
  { parte: 'Painel elétrico', tarefa: 'Medir a temperatura dos componentes e conexões com pirômetro.', metodo: 'Manutenção preditiva', periodicidade: 'Trimestral', responsavel: 'Manutenção' },
  { parte: 'Painel elétrico', tarefa: 'Medir as grandezas elétricas (tensão e corrente) com multímetro.', metodo: 'Manutenção preditiva', periodicidade: 'Trimestral', responsavel: 'Manutenção' },
  { parte: 'Sistema de acionamento (motor)', tarefa: 'Verificar a vedação da caixa de ligação do motor: furos abertos e tampa íntegra. Vedar se necessário.', metodo: 'Inspeção visual', periodicidade: 'Trimestral', responsavel: 'Manutenção' },
  { parte: 'Sistema de acionamento (motor)', tarefa: 'Medir, no painel, a corrente e a tensão de alimentação do motor com alicate amperímetro e voltímetro.', metodo: 'Manutenção preditiva', periodicidade: 'Semestral', responsavel: 'Manutenção' },
  { parte: 'Sistema de acionamento (motor)', tarefa: 'Verificar a temperatura do eixo de transmissão com termômetro digital.', metodo: 'Manutenção preditiva', periodicidade: 'Semestral', responsavel: 'Manutenção' },
  { parte: 'Sistema de acionamento (motor)', tarefa: 'Verificar ruídos e vibrações anormais em motor, transmissão e cilindros com estetoscópio.', metodo: 'Manutenção preditiva', periodicidade: 'Semestral', responsavel: 'Manutenção' },
  { parte: 'Sistema hidráulico', tarefa: 'Verificar vazamentos em mangueiras, conexões e cilindros. Despressurizar o sistema antes de qualquer correção, mesmo em gotejamento lento.', metodo: 'Inspeção visual', periodicidade: 'Trimestral', responsavel: 'Manutenção' },
  { parte: 'Sistema hidráulico', tarefa: 'Reapertar as conexões de todo o sistema hidráulico com as ferramentas adequadas.', metodo: 'Manutenção preventiva', periodicidade: 'Trimestral', responsavel: 'Manutenção' },
  { parte: 'Sistema hidráulico', tarefa: 'Verificar o nível e o aspecto do óleo hidráulico no visor do reservatório.', metodo: 'Inspeção visual', periodicidade: 'Semanal', responsavel: 'Operação' },
  { parte: 'Sistema pneumático', tarefa: 'Verificar vazamentos, pressão de trabalho e dreno do conjunto filtro-regulador.', metodo: 'Inspeção visual', periodicidade: 'Semanal', responsavel: 'Operação' },
  { parte: 'Sinalização de segurança', tarefa: 'Verificar legibilidade e fixação de pictogramas, plaquetas e demarcação de piso.', metodo: 'Inspeção visual', periodicidade: 'Mensal', responsavel: 'Operação' },
  { parte: 'Máquina e seus entornos', tarefa: 'Limpar a máquina e a área de trabalho com pano úmido e produto de limpeza adequado.', metodo: 'Limpeza', periodicidade: 'Semanal', responsavel: 'Operação' },
  { parte: 'Máquina e seus entornos', tarefa: 'Limpar o piso no entorno da máquina com vassoura e pano úmido com produto de limpeza adequado.', metodo: 'Limpeza', periodicidade: 'Semanal', responsavel: 'Operação' },
  { parte: 'Máquina e seus entornos', tarefa: 'Limpar externamente o painel elétrico de controle com pano úmido e produto de limpeza adequado.', metodo: 'Limpeza', periodicidade: 'Semanal', responsavel: 'Operação' },
];

/**
 * Lista de falhas do manual-modelo, generalizada. Mesma regra do plano: entra
 * pronta e o levantamento apaga o que não se aplica.
 */
export const FALHAS_PADRAO: { falha: string; causa: string; solucao: string }[] = [
  { falha: 'A máquina não inicia a operação.', causa: 'Dispositivo de segurança atuado: proteção aberta, botão de emergência acionado ou rearme pendente.', solucao: 'Verificar e corrigir as causas possíveis: fechar as portas e proteções; desatuar o botão de emergência; efetuar o rearme elétrico da máquina.' },
  { falha: 'A máquina não inicia a operação.', causa: 'Dispositivo de proteção térmica do motor forçou o desligamento.', solucao: 'Restaurar o dispositivo de proteção térmica; verificar se a carga da máquina está definida acima do valor previsto.' },
  { falha: 'A máquina não rearma.', causa: 'Circuito de segurança em falha.', solucao: 'Fechar a proteção; desatuar os botões de emergência; efetuar o rearme elétrico; verificar a ligação elétrica do rearme, a interface de segurança e o retorno (feedback) dos contatores; verificar se há contatores colados.' },
  { falha: 'O motor de acionamento desliga termicamente.', causa: 'Motor elétrico sobrecarregado ou queimado.', solucao: 'Verificar a carga de trabalho e a ventilação do motor; substituir o motor se estiver queimado.' },
  { falha: 'Perda ou instabilidade de força no movimento de trabalho.', causa: 'Óleo hidráulico contaminado, nível baixo ou pressão desajustada.', solucao: 'Verificar contaminação e nível do óleo; corrigir a pressão de trabalho; substituir o filtro.' },
  { falha: 'Lubrificação automática interrompida ou ruído elevado.', causa: 'Reservatório de lubrificante vazio ou fluido diluído pelo calor.', solucao: 'Verificar o conteúdo do reservatório e completar ou substituir se estiver vazio; verificar a temperatura de trabalho, pois o calor dilui o fluido e impede a lubrificação.' },
  { falha: 'Parada inesperada durante o ciclo.', causa: 'Abertura de proteção intertravada, queda de tensão ou atuação de emergência.', solucao: 'Verificar o fechamento das proteções e a alimentação elétrica; rearmar e reiniciar o ciclo.' },
  { falha: 'Vazamento de óleo ou de ar.', causa: 'Vedações, mangueiras ou conexões danificadas ou frouxas.', solucao: 'Despressurizar o sistema; substituir vedações ou mangueiras; reapertar as conexões.' },
  { falha: 'O botão de emergência não para a máquina.', causa: 'Falha no contato ou na fiação do dispositivo.', solucao: 'Interditar a máquina e acionar a manutenção para verificar o circuito de segurança antes de retomar a operação.' },
];

export const CATALOGO_PRECAUCOES = [
  'Não operar a máquina sem as proteções instaladas e íntegras.',
  'Manter a área de operação livre de pessoas não autorizadas.',
  'Não utilizar adornos, roupas soltas ou cabelos soltos durante a operação.',
  'Verificar o funcionamento da parada de emergência antes de iniciar o turno.',
  'Bloquear e etiquetar as fontes de energia antes de qualquer intervenção.',
  'Não realizar limpeza ou ajuste com a máquina em movimento.',
  'Comunicar imediatamente qualquer ruído, vazamento ou comportamento anormal.',
];

export const CATALOGO_USOS_PROIBIDOS = [
  'Utilizar a máquina para finalidade diferente da prevista neste manual.',
  'Operar o equipamento com proteções removidas, danificadas ou neutralizadas.',
  'Processar material fora das especificações e da capacidade indicadas.',
  'Permitir a operação por profissional não capacitado ou não autorizado.',
  'Realizar improvisos, adaptações ou reparos provisórios nos dispositivos de segurança.',
];

export const CATALOGO_VISTAS = [
  'Vista panorâmica',
  'Vista frontal',
  'Vista lateral direita',
  'Vista lateral esquerda',
  'Vista traseira',
  'Vista superior',
  'Painel de comando',
  'Detalhe da zona de trabalho',
];

export const GLOSSARIO_PADRAO = [
  { termo: 'Apreciação de risco', definicao: 'Processo de identificação de perigos, estimativa e avaliação dos riscos associados ao equipamento.' },
  { termo: 'Dispositivo de intertravamento', definicao: 'Dispositivo que impede o funcionamento de elementos perigosos enquanto a proteção não estiver fechada.' },
  { termo: 'Energia residual', definicao: 'Energia armazenada que permanece no equipamento após o desligamento das fontes de alimentação.' },
  { termo: 'Perigo indissociável', definicao: 'Perigo que permanece presente mesmo após a aplicação das medidas de proteção disponíveis.' },
  { termo: 'Proteção fixa', definicao: 'Barreira mantida em posição de forma permanente ou por meio de fixadores que exigem ferramenta para remoção.' },
  { termo: 'Parada de emergência', definicao: 'Função destinada a interromper um processo perigoso no menor tempo possível.' },
  { termo: 'Uso previsto', definicao: 'Utilização do equipamento conforme as informações fornecidas neste manual.' },
  { termo: 'Zona de perigo', definicao: 'Espaço dentro ou ao redor da máquina em que há exposição a risco de lesão.' },
];

export const ABREVIATURAS_PADRAO = [
  { termo: 'EPI', definicao: 'Equipamento de Proteção Individual' },
  { termo: 'EPC', definicao: 'Equipamento de Proteção Coletiva' },
  { termo: 'NR', definicao: 'Norma Regulamentadora' },
  { termo: 'ABNT', definicao: 'Associação Brasileira de Normas Técnicas' },
  { termo: 'PL', definicao: 'Performance Level (nível de desempenho)' },
  { termo: 'LOTO', definicao: 'Lockout/Tagout — bloqueio e etiquetagem de energias' },
  { termo: 'N/I', definicao: 'Não informado no levantamento' },
  { termo: 'CLP', definicao: 'Controlador Lógico Programável' },
];
